import React from "react";
import { ButtonOld } from "components/ButtonOld/ButtonOld";
import { ButtonGroup } from "components/ButtonOld/ButtonGroup";
import { DialogButton } from "gui/dialog/dialog";
import { FullDashboard } from "lib/entries/types";
import { FieldButtons } from "gui/input/fields";
import { Fields } from "gui/input/fields";
import { TextWidgetFields } from "gui/widgets/edit";
import { callUpsertTextWidget } from "gui/widgets/graphql";
import { useErrorBoundary } from "lib/hooks/use-error-boundary";
import { useRequiredSession } from "gui/session/session";
import { Button } from "components/Button/Button";
import { Tooltip } from "components/Tooltip/Tooltip";

export const WidgetsTextButton: React.FC<{
  dashboard: FullDashboard;
  refresh?: () => void;
}> = (props) => {
  if (props.dashboard.is_archived) {
    return (
      <Tooltip
        label="Archived dashboards cannot be updated"
        position="below-center"
      >
        <Button size="M" theme="tertiary" disabled>
          Add text widget
        </Button>
      </Tooltip>
    );
  }

  return (
    <DialogButton label="Add text widget" size="md">
      {(onDismiss) => <WidgetsTextDialog {...props} onDismiss={onDismiss} />}
    </DialogButton>
  );
};

const WidgetsTextDialog: React.FC<{
  dashboard: FullDashboard;
  refresh?: () => void;
  onDismiss: () => void;
}> = (props) => {
  const [loading, setLoading] = React.useState(false);
  const [text, setText] = React.useState("");
  const session = useRequiredSession();
  const setError = useErrorBoundary();

  const onSubmit = (event: React.SyntheticEvent) => {
    event.preventDefault();
    setLoading(true);
    callUpsertTextWidget(props.dashboard, undefined, text, session)
      .then(() => props.refresh?.())
      .then(() => props.onDismiss())
      .catch(setError);
  };

  return (
    <form onSubmit={onSubmit}>
      <Fields>
        <TextWidgetFields text={text} setText={setText} />
        <FieldButtons>
          <ButtonGroup>
            <ButtonOld
              loading={loading}
              disabled={!text}
              type="submit"
              size="sm"
              color2
            >
              Save
            </ButtonOld>
            <ButtonOld
              onClick={props.onDismiss}
              loading={loading}
              size="sm"
              color2
              light
            >
              Cancel
            </ButtonOld>
          </ButtonGroup>
        </FieldButtons>
      </Fields>
    </form>
  );
};
